import * as debug from './debug.service';
import { Injectable } from '@angular/core';
import {
	Resolve,
	RouterStateSnapshot,
	ActivatedRouteSnapshot
} from '@angular/router';
import { Observable, of, from } from 'rxjs';
import { catchError, tap, switchMap, take, finalize } from 'rxjs/operators';
import { IUserProfile } from '../responses/iuser-profile';
import { SecurityService } from './security.service';
import { appUrl } from 'src/environments/environment';
import { fallbackMenu } from '../utils/utility.common';
import { MenuService } from './menu.service';
import { ProfileDbService } from './profile-db.service';

@Injectable({ providedIn: 'root' })
export class MenuResolverService implements Resolve<IUserProfile> {

	constructor(private readonly securityService: SecurityService
		, private readonly menuService: MenuService
		, private readonly profileDbService: ProfileDbService
	) {
		debug.log('013 MenuResolverService instantiated');
	}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IUserProfile> | Promise<IUserProfile> | IUserProfile {
		debug.log('014 MenuResolverService resolve');

		let isLoggedIn2 = false;
		debug.log('014.1 MenuResolverService isBusy = true');
		this.menuService.setIsBusy(true);
		// handle anonymous getGuestProfile

		let hasError = false;

		const securityServiceIsLoggedIn = this.securityService.isLoggedIn('015 MenuResolverService');
		const combined = from(securityServiceIsLoggedIn)
			.pipe(
				switchMap(isLoggedIn => {
					isLoggedIn2 = isLoggedIn;

					return from(this.profileDbService.getLocalProfile(isLoggedIn, '016 MenuResolverService resolve')); // Retrieve from local Db
				}),
				switchMap(localDbProfile => {
					if (!!localDbProfile.id || !isLoggedIn2) {
						debug.log(`017 MenuResolverService isLoggedIn: ${isLoggedIn2} Reusing localDbProfile`);

						return of(localDbProfile);
					}

					// debug.log(`018 MenuResolverService isLoggedIn: ${isLoggedIn2} localDbProfile id not found. Retrieving profile from the server: ${url}`);

					return this.securityService.getUserProfile(appUrl.userProfile, `019 MenuResolverService.resolve`);
				}),
				take(1),
				tap(profile => {
					if (profile) {

						debug.log(`020 MenuResolverService Profile data found: `, profile);

						this.menuService.initialize(profile, `020.1 MenuResolverService resolve`);

						return of(profile);

					} else { // id not found
						const url = appUrl.guestProfile;

						debug.log(`021 MenuResolverService Profile data not found: ${url}. Returning fallbackMenu`);

						this.menuService.initialize(fallbackMenu, `020.2 MenuResolverService resolve`);

						return of(fallbackMenu);
					}
				}),
				catchError(error => {

					const url = appUrl.guestProfile;

					debug.warn(`022 MenuResolverService catchError ${url}. Returning fallbackMenu`, error);
					hasError = true;
					//  return this.globalErrorHandler.handleError(error);

					return of(fallbackMenu);

				}),
				finalize(() => {

					debug.log('022.1 MenuResolverService finalize isBusy = false');

					this.menuService.setIsBusy(false);

					if (hasError) {

						debug.log('022.2 MenuResolverService hasError returning fallbackMenu..');

						return of(fallbackMenu);

					}
				})
			);

		return combined;
	}
}
